/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import DashletSuccessIcon from '../../components/elements/DashletSuccessIcon'
import DashletDeclineIcon from '../../components/elements/DashletDeclineIcon'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'
import { OVERRIDE_FIELDS } from '../../constants'
import OverrideTag from '../../components/elements/OverrideTag'

export default function CustomerDashlet({ endpointPath, dropdownOptions }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [module, setModule] = useState()
  const modules = useSelector(selectModules)

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        const rowData = response.data.data;

        setRow(rowData);

        const m = modules.data.find((e) => e.code_key === 'customer')
        setModule(m)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if (!requesting.current && endpointPath && row.length === 0) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [endpointPath])

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name;
    }
    const data = module.module_fields.find(
      (header) => header.column_name === column_name
    )
    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  const displayTag = (fieldName, value) => {
    // CustomerDashlet is customer-only, so the OVERRIDE_FIELDS.customer hardcode is intentional here
    // (no module variable to key off). The generic consumers (DisplayField, FormFieldBuilder, TableRow)
    // key off OVERRIDE_FIELDS[module_code_key] instead.
    if (fieldName in OVERRIDE_FIELDS.customer && row[OVERRIDE_FIELDS.customer[fieldName].override_field] !== null && row[OVERRIDE_FIELDS.customer[fieldName].override_source_field] !== null) {
      return <OverrideTag value={value} sourceCodeKeyId={row[OVERRIDE_FIELDS.customer[fieldName].override_source_field]} />
    } else {
      return value
    }
  };

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Customer Detail</p>
      </div>
      <div className="message-body py-0 px-1" style={{ lineHeight: 1.40 }}>
        {loaded && row && row.id && (
          <>
            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader("id")}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-link is-size-8">
                <Link
                  key={`loan-dashlet-view-${row.id}`}
                  to={`/customer/${row.id}`}
                  className="lox-has-text-decoration-none"
                >
                  {row.id}
                </Link>
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Full Name', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {(row.full_name) ? `${row.full_name}` : '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('email_address')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {displayTag('email_address', row.email_address) || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('city')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.city || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('state_dropdown_option_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {dropdownOptions[row.state_dropdown_option_id]?.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('zip_code_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.zip_code_label || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1" style={{ maxHeight: "60px" }}>
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('home_phone_number')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {displayTag('home_phone_number', row.home_phone_number) || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1" style={{ maxHeight: "60px" }}>
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('cell_phone_number')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {displayTag('cell_phone_number', row.cell_phone_number) || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('pay_frequency_dropdown_option_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {dropdownOptions[row.pay_frequency_dropdown_option_id]?.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('is_do_not_call')}
              </p>
              <p className="lox-dashlet-detail__item__data is-size-8 px-0 lox-dashlet-detail__icon">
                {row.is_do_not_call == 0 ? (
                  <DashletDeclineIcon />
                ) : (
                  <DashletSuccessIcon />
                )}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('customer_status_dropdown_option_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {dropdownOptions[row.customer_status_dropdown_option_id]?.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('portfolio_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.portfolio_label || '-'}
              </p>
            </div>
          </>
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}
